import { render, staticRenderFns } from "./StockistCard.vue?vue&type=template&id=5f5e5ad9&"
import script from "./StockistCard.vue?vue&type=script&lang=js&"
export * from "./StockistCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports